<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col
        cols="12"
        md="6"
        offset-md="6"
        class="pa-2 d-flex align-center justify-end"
      >
        <v-btn icon class="mr-3" @click="toggleSearch = !toggleSearch">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon color="accent" class="mr-3" @click="getCourses">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
        <v-btn
          :ripple="false"
          depressed
          color="primary"
          @click="openDialog"
        >
          <v-icon class="mr-3">mdi-plus-circle</v-icon>
          {{ $t("actions.createCourse") }}
        </v-btn>
      </v-col>
      <v-col v-if="toggleSearch" cols="12" class="pa-2 pt-0">
        <v-text-field
          v-model="search"
          :label="$t('actions.search')"
          hide-details
          width="100%"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pa-2 d-flex flex-column">
        <v-card height="100%" class="d-flex flex-column elevation-3 pa-2">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :custom-filter="coursesFilter"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:[`item.color`]="{ item }">
              <v-avatar
                size="20"
                :color="item.color"
              />
            </template>
            <template v-slot:[`item.numberOfHoles`]="{ item }">{{ item.holes.length }}</template>
            <template v-slot:[`item.isEnabled`]="{ item }">
              <v-avatar
                size="20"
                :color="item.isEnabled ? 'success' : 'red darken-2'"
              />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small @click="alterAction('toggle', item.id)">
                      <template v-if="item.isEnabled">mdi-cancel</template>
                      <template v-else>mdi-check</template>
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ item.isEnabled ? $t('courses.disable') : $t('courses.enable') }}</span>
              </v-tooltip>

              <v-btn small icon>
                <v-icon small @click="alterAction('show', item.id)">
                  mdi-eye
                </v-icon>
              </v-btn>
              <v-btn small icon>
                <v-icon small @click="alterAction('edit', item.id)">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn v-if="!item.isExternal" small icon>
                <v-icon small @click="alterAction('delete', item.id)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-spacer />
          <div class="text-center ml-auto pt-2">
            <v-pagination v-model="page" circle :length="pageCount" />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <course-dialog
      v-model="object"
      :show-dialog="dialog"
      :readonly="!isEditting"
      @toggle-dialog="(state) => (dialog = state)"
      @set-readonly="(state) => (isEditting = state)"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import list from 'GraphQL/queries/courses/list.gql'
import deleteMutation from 'GraphQL/mutations/courses/delete.gql'
import toggleMutation from 'GraphQL/mutations/courses/toggle.gql'
import importCourses from '@/graphql/mutations/courses/import.gql'

import { Dialog as CourseDialog } from 'Components/courses'

import { filters } from '@/mixins'

const dayjs = require('dayjs')
require('dayjs/locale/es')
dayjs.locale('es')

export default {
  components: {
    CourseDialog
  },
  mixins: [filters],
  data () {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      isEditting: false,
      object: {},
      dialog: false,
      search: '',
      toggleSearch: false
    }
  },
  computed: {
    ...mapState(['isDark', 'courses', 'users']),

    headers () {
      return [
        {
          text: this.$i18n.t('courses.name'),
          align: 'center',
          sortable: true,
          value: 'name'
        },
        { text: this.$i18n.t('courses.color'), value: 'color', sortable: false },
        { text: this.$i18n.t('courses.numberOfHoles'), value: 'numberOfHoles', sortable: false },
        { text: this.$i18n.t('courses.state'), value: 'isEnabled', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ]
    },

    data () {
      return this.courses.list
    }
  },
  created () {
    this.object = Object.assign({}, this.$store.getters['courses/defaultObject'])
  },
  methods: {
    openDialog () {
      this.dialog = true
      this.isEditting = true
      this.object = Object.assign(
        {},
        this.$store.getters['courses/defaultObject']
      )
    },
    evaluateResponse ({ status, errors, result, action }) {
      this.isLoading = false
      console.log(action)
      switch (status) {
        case 'OK':
          if (action === 'import') {
            this.$store.commit('toggleSnackbar', {
              color: 'success',
              message: this.$t('helpers.import.success')
            })
            this.$store.dispatch('courses/getList', true)
          } else if (action === 'toggle') {
            const message = result.isEnabled ? this.$t('helpers.course.enabled') : this.$t('helpers.course.disabled')
            this.$store.commit('toggleSnackbar', {
              color: 'success',
              message
            })
            this.$store.dispatch('courses/getList', true)
          } else if (action !== 'delete') {
            this.object = result[0]
            this.dialog = true
          } else {
            this.$store.dispatch('courses/getList', true)
          }
          break
        case 'UNPROCESSABLE':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'BADREQUEST':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'ACCESSDENIED':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.accessdenied')
          })
          break
      }
    },
    getDetail (id, action) {
      console.log(id)
      this.$apollo
        .query({
          query: list,
          variables: {
            token: this.users.entity.token,
            id: id
          },
          fetchPolicy: 'no-cache'
        })
        .then((response) => {
          const { status, errors, result } = response.data.courses
          this.evaluateResponse({ status, errors, result, action })
        })
        .catch((err) => {
          console.log('Error handled', err)
          this.$store.commit('toggleSnackbar', {
            color: 'red darken-2',
            message: this.$t('helpers.errors.disaster')
          })
        })
    },

    deleteItem (id, action) {
      this.$apollo
        .mutate({
          mutation: deleteMutation,
          variables: {
            token: this.users.entity.token,
            ids: [id]
          },
          fetchPolicy: 'no-cache'
        })
        .then((response) => {
          const { status, errors, result } = response.data.deleteCourses
          this.evaluateResponse({ status, errors, result, action })
        })
        .catch((err) => {
          console.log('Error handled', err)
          this.$store.commit('toggleSnackbar', {
            color: 'red darken-2',
            message: this.$t('helpers.errors.disaster')
          })
        })
    },

    toggleItem (id, action) {
      this.$apollo
        .mutate({
          mutation: toggleMutation,
          variables: {
            token: this.users.entity.token,
            id: id
          },
          fetchPolicy: 'no-cache'
        })
        .then((response) => {
          const { status, errors, result } = response.data.toggleCourse
          this.evaluateResponse({ status, errors, result, action })
        })
        .catch((err) => {
          console.log('Error handled', err)
          this.$store.commit('toggleSnackbar', {
            color: 'red darken-2',
            message: this.$t('helpers.errors.disaster')
          })
        })
    },

    alterAction (action, id) {
      if (action === 'show') {
        this.isEditting = false
        this.getDetail(id, action)
      } else if (action === 'edit') {
        this.isEditting = true
        this.getDetail(id, action)
      } else if (action === 'toggle') {
        this.toggleItem(id, action)
      } else {
        this.deleteItem(id, action)
      }
    },

    showCourse (item) {
      this.object = Object.assign({}, item)
      this.dialog = true
      this.isEditting = false
    },

    getCourses () {
      this.$apollo
        .mutate({
          mutation: importCourses,
          variables: {
            token: this.users.entity.token
          },
          fetchPolicy: 'no-cache'
        })
        .then((response) => {
          const { status, errors } = response.data.importCourses
          this.evaluateResponse({ status, errors, result: null, action: 'import' })
        })
        .catch((err) => {
          console.log('Error handled', err)
          this.$store.commit('toggleSnackbar', {
            color: 'red darken-2',
            message: this.$t('helpers.errors.disaster')
          })
        })
    }
  }
}
</script>
